const TableContainer = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      overflowX: "auto",
      scrollbarWidth: "thin",
    }),
  },
};

export default TableContainer;
